module.exports = __webpack_public_path__ + "static/media/ask_icon.a1b8ea76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ask_icon.png
// module id = 1806
// module chunks = 0